import React from 'react'

export default function HomePlatformMessageAr() {
  return (
    <p className="text-4xl font-black leading-[1.75] xl:text-5xl xl:leading-[1.8]">
      <span className="text-secondary-600">الموارد المعدنية العربية </span>
      <br />
      جسر التنمية لمستقبل <br />
      <span className="text-third">أفضل ومستدام</span>
    </p>
  )
}
